<button [class]="baseClasses" [disabled]="disabled">
  <ng-content></ng-content>
</button>
